function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#67ADB6",
  fillRule: "evenodd",
  d: "M1.751 34.471C.888 32.767.394 30.877.394 28.944.394 9.785 20.651.76 25.725.76c.376 0 .376 1.484 0 2.225C23.053 4.44 15.17 9.62 14.85 18.03c5.485 1.046 9.632 5.867 9.632 11.656 0 6.554-5.313 11.867-11.867 11.867-4.851 0-9.023-2.91-10.863-7.08zm30.356 0c-.864-1.704-1.357-3.594-1.357-5.527C30.75 9.785 51.006.76 56.08.76c.376 0 .376 1.484 0 2.225C53.41 4.44 45.527 9.62 45.205 18.03c5.486 1.046 9.632 5.867 9.632 11.656 0 6.554-5.313 11.867-11.867 11.867-4.85 0-9.022-2.91-10.862-7.08z"
});

var SvgRoundQuotesStart = function SvgRoundQuotesStart(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 57,
    height: 42,
    viewBox: "0 0 57 42",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRoundQuotesStart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/round-quotes-start.2878de49.svg";
export { ForwardRef as ReactComponent };